import { Col, Row } from "react-bootstrap";
import Sidebar from "../../components/Sidebar/Sidebar"

import { Outlet } from "react-router-dom";
import "./Layout.css";

export default function Layout() {
  return (
    <>
    <Row className="row-layout">
      <Col className="col" md={2} sm={0} ><Sidebar /></Col>
      <Col className="col" md={10} sm={12} >
      
      <Outlet />
      </Col>
    </Row>
    </>
  )
}


